<template>
  <a-modal :visible="visible" title="操作" @ok="ruleSubmit" @cancel="onClose">
    <a-form :form="form">
      <a-form-item
        label="权限名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请输入权限名称' }] }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="权限编码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'code',
            { rules: [{ required: true, message: '请输入权限编码' }] }
          ]"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      labelCol: { lg: { span: 7 }, sm: { span: 7 } },
      wrapperCol: { lg: { span: 10 }, sm: { span: 17 } }
    };
  },
  methods: {
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    ruleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((error, values) => {
        if (error) {
          console.log(error);
        } else {
          this.$emit("ok", values);
          this.onClose();
        }
      });
    }
  }
};
</script>

<style></style>
